import httpInstances from '@/api/axiosInstance';

import type { InitializeChatResponse, SendMessageArgs } from '../types/chat';

export const BASE_PATH = 'go/chatbot/chat';
const { axiosInternalInstance } = httpInstances;

export async function initializeChat(): Promise<InitializeChatResponse> {
  const response = await axiosInternalInstance.post(`${BASE_PATH}/initialize`);
  return response.data as InitializeChatResponse;
}

// Opens a streaming chat request and returns a reader
export async function openChatStream(
  params: SendMessageArgs,
  signal: AbortSignal
): Promise<ReadableStreamDefaultReader<Uint8Array> | null> {
  const { conversationId, message, userId } = params;
  const response = await axiosInternalInstance.post(
    BASE_PATH,
    { conversation_id: conversationId, message, user_id: userId },
    { adapter: 'fetch', responseType: 'stream', signal: signal as any }
  );
  const reader = response.data?.getReader?.();
  return reader ?? null;
}
